import mainTranslations from "../modules/main/_langs/en-US";
import settingsTranslations from "../modules/settings/_langs/en-US";

export default {
  main: mainTranslations,
  settings: settingsTranslations,
};
